import script from "./ProductionPlanDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionPlanDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductionPlanDetailModal.vue?vue&type=style&index=0&id=48a5871c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a5871c"]])

export default __exports__